import api from "@/services/api";

const state = {
  account: null,
};

const getters = {
  account: (state) => state.account,
};

const mutations = {
  SET_ACCOUNT(state, payload) {
    state.account = payload;
  },
};

const actions = {
  async getAccount({ commit }) {
    try {
      const res = await api.get("/bank/bank-account");
      commit("SET_ACCOUNT", res.data);
    } catch (error) {
      console.error("Error fetching bank account:", error.message);
      throw error;
    }
  },

  async saveAccount({ dispatch }, payload) {
    try {
      await api.put("/bank/bank-account", payload);
      await dispatch("getAccount");
    } catch (error) {
      console.error("Error saving bank account:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};